export default __webpack_public_path__ + "static/media/supply-chain.cb99f1ae.png";